import styles from './tabs.module.scss';
import MaterialTabs from '@mui/material/Tabs';
import MaterialTab from '@mui/material/Tab';
import MaterialTabContext from '@mui/lab/TabContext';
import MaterialTabList from '@mui/lab/TabList';
import MaterialTabPanel from '@mui/lab/TabPanel';
import MaterialTabScrollButton from '@mui/material/TabScrollButton';
import { ReactNode } from 'react';

/* eslint-disable-next-line */
export interface TabsProps {
  // action?: any,
  allowScrollButtonsMobile?: boolean,
  // ariaLabel?: string,
  // ariaLabelledby?: string,
  // centered?: boolean,
  children?: any,
  // classes?: object,
  // component?: any,
  indicatorColor?: 'primary' | 'secondary',
  onChange?: (event: any, value: any) => void,
  // orientation?: 'horizontal' | 'vertical',
  // ScrollButtonComponent?: any,
  scrollButtons?: 'auto' | false | true,
  // selectionFollowsFocus?: boolean,
  // sx?: any,
  // TabIndicatorProps?: object,
  // TabScrollButtonProps?: object,
  textColor?: 'inherit' | 'primary' | 'secondary',
  value?: any,
  variant?: 'fullWidth' | 'scrollable' | 'standard',
  // visibleScrollbar?: boolean,
  // className?: string,
  'data-testid'?: string
  'aria-label'?: string
}

export interface TabProps {
  id?: string,
  'aria-controls'?: string,
  // classes?: object,
  disabled?: boolean,
  // disableFocusRipple?: boolean,
  // disableRipple?: boolean,
  // icon?: string,
  // iconPosition?: 'bottom' | 'end' | 'start' | 'top',
  label?: ReactNode,
  sx?: any,
  value?: any,
  // wrapped?: boolean,
  onClick?: () => void,
  'data-testid'?: string
}

export interface TabContextProps {
  value: string,
  children?: any
}

export interface TabListProps {
  children?: any,
  onChange?: (event: any, newValue: any) => void
}

export interface TabPanelProps {
  value: string,
  children?: any,
  // classes?: object,
  sx?: any
}

export interface TabScrollButtonProps {
  direction: 'left' | 'right',
  orientation: 'horizontal' | 'vertical',
  children?: any,
  // classes?: object,
  disabled?: boolean,
  sx?: any
}

export function Tabs(props: TabsProps) {
  return (
    <MaterialTabs
      value={props.value}
      onChange={props.onChange}
      textColor={props.textColor}
      indicatorColor={props.indicatorColor}
      variant={props.variant}
      scrollButtons={props.scrollButtons}
      allowScrollButtonsMobile={props.allowScrollButtonsMobile}
      aria-label={props['aria-label']}
      data-testid={props['data-testid']}>
      {props.children}
    </MaterialTabs>
  );
}

export function Tab(props: TabProps) {
  // MaterialTabs injects selection and keyboard props into its children.
  return (
    <MaterialTab {...props} />
  );
}

export function TabContext(props: TabContextProps) {
  return (
    <MaterialTabContext
      value={props.value}>
      {props.children}
    </MaterialTabContext>
  );
}

export function TabList(props: TabListProps) {
  return (
    <MaterialTabList
      onChange={props.onChange}>
      {props.children}
    </MaterialTabList>
  );
}

export function TabPanel(props: TabPanelProps) {
  return (
    <MaterialTabPanel
      value={props.value}
      sx={props.sx}>
      {props.children}
    </MaterialTabPanel>
  );
}

export function TabScrollButton(props: TabScrollButtonProps) {
  return (
    <MaterialTabScrollButton
      direction={props.direction}
      orientation={props.orientation}
      disabled={props.disabled}
      sx={props.sx}>
      {props.children}
    </MaterialTabScrollButton>
  );
}

export default Tabs;